import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteWarehouse } from "../../api/apiInventory";
import parseError from "../../utils/parseError";

export const useDeleteWarehouse = () => {
    const queryClient = useQueryClient();
    const { mutate: deleteWarehouseMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteWarehouse,
        onSuccess: (res) => {
            toast.success(res.message || "Warehouse deleted");
            queryClient.invalidateQueries(["warehouses"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to delete warehouse"),
    });
    return { deleteWarehouseMutate, isDeleting };
};
